import type { PlannedRouteStatus } from "@/lib/reseller-api";

export const ROUTE_STATUSES: PlannedRouteStatus[] = ["planned", "in_progress", "completed", "cancelled"];

export const ROUTE_STATUS_BADGE: Record<PlannedRouteStatus, string> = {
  planned: "bg-blue-500/15 text-blue-700 dark:text-blue-400 border-transparent",
  in_progress: "bg-amber-500/15 text-amber-700 dark:text-amber-400 border-transparent",
  completed: "bg-green-500/15 text-green-700 dark:text-green-400 border-transparent",
  cancelled: "bg-muted text-muted-foreground border-transparent",
};

export const formatDistance = (meters: number | null | undefined) =>
  meters == null ? "-" : `${(meters / 1000).toLocaleString(undefined, { maximumFractionDigits: 1 })} km`;

export const formatDuration = (seconds: number | null | undefined) => {
  if (seconds == null) return "-";
  const minutes = Math.round(seconds / 60);
  return minutes < 60 ? `${minutes} min` : `${Math.floor(minutes / 60)} h ${String(minutes % 60).padStart(2, "0")}`;
};
